// Nav.js
import React from 'react';
import styled from 'styled-components';
import NavLinkContainer from './NavLinkContainer';

const NavStyled = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: -250px;
  padding: 15px;
  backdrop-filter: blur(5px);
  border-radius: 50px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  
  @media (max-width: 768px) {
    margin-top: -150px;
    flex-wrap: wrap;
  }
`;

const Nav = ({ activeLink, handleLinkClick }) => (
  <NavStyled>
    <NavLinkContainer
      link="home"
      isActive={activeLink === 'home'}
      handleLinkClick={handleLinkClick}
      label="Home"
      to="/"
    />
    <NavLinkContainer
      link="memebuilder"
      isActive={activeLink === 'memebuilder'}
      handleLinkClick={handleLinkClick}
      label="MEME"
      to="/memebuilder"
    />
    
    
  </NavStyled>
);

export default Nav;
